export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";